<div class="d-flex flex-column flex-auto invalid-account-level-popup">
  <div class="header">
    <span class="header-title">{{'common.alert' | translate}}</span>
  </div>
  <span class="content">{{message}}</span>
  <div class="d-flex flex-auto justify-content-end">
    <button class="button lg-button blue" [class.support-btn]="!isSsoUser" (click)="contactSupport()">
      {{'common.btn.support' | translate}}
    </button>

    <ng-container *ngIf="!isSsoUser">
      <button *ngIf="needToUpgrade" class="button lg-button upgrade-btn" (click)="upgradeAccount()">
        {{'common.btn.upgrade_now' | translate}}
      </button>
      <button *ngIf="!needToUpgrade" class="button lg-button upgrade-btn" (click)="startTrial()">
        {{'common.btn.free_upgrade' | translate}}
      </button>
    </ng-container>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/main/invalid-account-level-notification/invalid-account-level-notification.component.html